import { render } from "./HomeLayoutFooter.vue?vue&type=template&id=1536a256&ts=true"
import script from "./HomeLayoutFooter.vue?vue&type=script&lang=ts"
export * from "./HomeLayoutFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__